export default __webpack_public_path__ + "static/custom2-7af25f213df81cf152d6d6468fe45c98.png";